// article.guard.ts (recommended pattern)
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CACHE_KEYS } from '../../constants/cache-keys';
import { LPMI_ROUTES } from '../../constants/routes';
import { CacheService } from '../cache.service';

@Injectable({ providedIn: 'root' })
export class ArticleGuard implements CanActivate {
  constructor(private router: Router, private cacheService: CacheService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const token = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_DATA);

    if (!token) {
      this.cacheService.addToCache(CACHE_KEYS.ARTICLE.REDIRECT_URL, state.url);
      return this.router.createUrlTree(['/', LPMI_ROUTES.LOGIN.PATH], {
        queryParams: { articleRedirectUrl: state.url },
      });
    }
    return true;
  }
}